import { VlLayoutDefault } from '@vuelib/layouts';
import Vue from 'vue';
import VueRouter from 'vue-router';
import mycompanies from './mycompanies'; // eslint-disable-line
import mytransactions from './mytransactions'; // eslint-disable-line
import myusers from './myusers'; // eslint-disable-line
import store from '@/store'; // eslint-disable-line
import vuetify from '@/plugins/vuetify'; // eslint-disable-line

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,

  scrollBehavior: () => (false),

  routes: [
    {
      path: '/',
      component: VlLayoutDefault,
      children: [
        {
          path: '',
          name: 'dashboard',
          component: () => import(/* webpackChunkName: "dashboard" */ '@/views/index.vue'),
          meta: {
            roles: ['withoutrules', 'admin', 'developer', 'support', 'company'],
          },
        },
        {
          path: 'profile',
          name: 'profile',
          component: () => import(/* webpackChunkName: "profile" */ '@/views/profile.vue'),
          meta: {
            roles: ['withoutrules', 'admin', 'developer', 'support', 'company'],
          },
        },
        myusers,
        mytransactions,
        mycompanies,
      ],
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});

const oldPush = router.push;
router.push = function newRouterPush(...[route, ...args]) {
  if (route?.mouseEvent instanceof MouseEvent) {
    const $event = route.mouseEvent;
    const { href } = router.resolve(route);

    if ($event.ctrlKey || $event.shiftKey || $event.which === 2) {
      $event.stopPropagation();
      window.open(href, $event.shiftKey ? '_blank' : null);
    }

    return Promise.resolve();
  }
  return oldPush.apply(this, [route, ...args]);
};

router.beforeEach((to, from, next) => {
  if (to && to.meta && to.meta.roles) {
    const profile = store.getters['auth/profile'];
    if (profile && profile.tags) {
      if (profile.tags?.length === 0) {
        profile.tags.push({
          description: 'withoutrules',
        });
      }
      let validEntry = false;
      profile.tags.every((tag) => {
        to.meta.roles.every((role) => {
          if (tag.description === role) validEntry = true;
          return !validEntry;
        });
        return !validEntry;
      });

      if (validEntry) next();
      else next({ path: '/' });
    } else {
      next({ path: '/' });
    }
  } else {
    next();
  }
});

window.router = router;
export default router;
